import Vue from 'vue'
import vuetify from './vuetify'
import HighchartsVue from 'highcharts-vue';
import highcharts_extra from './highcharts';

// Vue2
export function registerPlugins() {
  Vue.use(HighchartsVue);
  Vue.use(highcharts_extra);
};

// // Vue3 way of doing this:
// export function registerPlugins (app) {
//   app
//     .use(HighchartsVue)
//     .use(highcharts_extra)
// }
